import { render, staticRenderFns } from "./reportEstate.vue?vue&type=template&id=61b42aa5&"
import script from "./reportEstate.vue?vue&type=script&lang=js&"
export * from "./reportEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports